import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      settings: {
        general_settings: {
          tabs: {
            upload_logo: {
              tab_name: 'TAB_NAME',
              choose_logo_mini: 'CHOOSE_LOGO_MINI',
              drop_logo_mini_here: 'DROP_LOGO_MINI_HERE',
              resolution_logo_mini: 'RESOLUTION_LOGO_MINI',
              choose_logo_main: 'CHOOSE_LOGO_MAIN',
              drop_logo_main_here: 'DROP_LOGO_MAIN_HERE',
              resolution_logo_main: 'RESOLUTION_LOGO_MAIN',
              choose_favicon: 'CHOOSE_FAVICON',
              drop_favicon_here: 'DROP_FAVICON_HERE',
              resolution_favicon: 'RESOLUTION_FAVICON',
            },
          },
        },
      },
    },
  }));
}
